export class Profissao {
  idGrupoProfissao: number;
  id: number;
  descricao: string;
}
